import classNames from "classnames";
import { Text } from "../Text/Text";

export type Tab = {
  label: string;
  value: string;
  onClick: () => void
}

interface Props {
  className?: string;
  active: string;
  tabs: Tab[]
}
 
export const Tabs = ({ className, active, tabs }: Props) => {
  return (
    <ul className={classNames('flex gap-x-5 gap-y-2 gap-5 flex-wrap', className)}>
      {tabs.map(({ label, value, onClick }) => {
        return (
          <li
            key={value} 
            className={classNames("flex-shrink-0", value === active && "border-b-[1px] border-black")}
          >
            <button onClick={onClick}>
              <Text 
                style="label"
                className={
                  classNames(
                    "transition-all duration-300ms",
                    value === active
                      ? "text-[var(--heading-color)" 
                      : "text-inactive-state",
                    "hover:text-[var(--heading-color)] focus-visible:text-[var(--heading-color)]"
                  )
                }
              >
                {label}
              </Text>
            </button>
          </li>
        )
      })}
    </ul>
  )
}